import React, {useRef} from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import PrintMovementNote from "./PrintMovementNote";
import PrintGoodsDelivery from "./PrintGoodsDelivery";
import {useReactToPrint} from "react-to-print";


export default function PrintOptionsModal({movement, open, setOpen}){

    const movementRef = useRef();
    const goodsRef = useRef();

    const handleNotePrint = useReactToPrint({contentRef: movementRef});
    const handleGoodsPrint = useReactToPrint({contentRef: goodsRef});


    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Which Print Out:</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                              color={"warning"}
                              onClick={handleGoodsPrint}
                            >
                              Print Goods Note
                            </Button>
                        </Column>
                        <Column>
                            <Button
                              color={"warning"}
                              onClick={handleNotePrint}
                            >
                              Print Movement Note
                            </Button>
                        </Column>
                        <Column>
                            <Button
                              color={"info"}
                              onClick={() => setOpen(false)}
                            >
                              Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
                <div style={{display: "none"}}>
                    <div ref={movementRef}>
                        <PrintMovementNote movement={movement}/>
                    </div>
                    <div ref={goodsRef}>
                        <PrintGoodsDelivery movement={movement}/>
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    );

}